import axios from './providers/axios';

const tagService = {
    getTags(page, filters = []) {
        let queryParams = `limit=20&page=${page}`;

        if (filters && filters.length > 0) {
            filters.forEach((filter) => {
                if (Array.isArray(filter.value)) {
                    filter.value.forEach((item, index) => {
                        Object.keys(item).forEach(key => {
                            queryParams += `&${filter.key}[${index}][${key}]=${item[key]}`;
                        });
                    });
                } else {
                    queryParams += `&${filter.key}=${filter.value}`;
                }
            });
        }

        return axios.get(`/v1/admin/tag/store?${queryParams}`);
    },
    getDefaultTags() {
        return axios.get('/v1/common/default?type[]=tag');
    },
    addTag(data) {
        return axios.post('/v1/admin/tag/add', data);
    },
    updateTag(data) {
        return axios.put('/v1/admin/tag/update', data);
    },
    deleteTag(id) {
        return axios.delete(`/v1/admin/tag/delete/${id}`);
    },
    getLogs(lang, page = 1, limit = 20){
        return axios.get(`/v1/admin/tag/getLogs?page=${page}&limit=${limit}`, {
            headers:{
                "Accept-Language": lang,
            }
        });
    },
}

export default tagService;
